import {
    Area,
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import { useSelector } from "react-redux";
import { formatNumber, formatter } from "../../utils/formatter";
import { ILegend, ITooltip } from "../../services/interface/IForecast";


const CustomLegend = (props: any) => {
    const { payload } = props;
    return (
        <ul className="flex items-center gap-2">
            {payload.map((entry: ILegend, index: number) => (
                <li key={`item-${index}`} className="flex items-center mb-1">
                    <svg width="40" height="10">
                        <line x1="0" y1="5" x2="15" y2="5" stroke={entry.color} strokeWidth="2" />
                        <polygon points="20,1 24,5 20,9 16,5" fill={entry.color} />
                        <line x1="25" y1="5" x2="40" y2="5" stroke={entry.color} strokeWidth="2" />
                    </svg>
                    <span style={{color:entry.color}} className="ml-2 font-semibold chart-legend">{entry.value}</span>
                </li>
            ))}
        </ul>
    );
};

const CustomTooltip = (props: any) => {
    const { active, payload } = props;
    if (active && payload && payload.length) {
        return (
            <div className="bg-[#fff] border-[1px] border-[#BEBEBE] p-2 rounded rs-bg">
                <p className="text-black text-fs16 font-bold mb-3">
                    {payload[0]?.payload?.forecastDate}
                </p>
                <div className="flex flex-row gap-2">
                    {payload?.map(($: ITooltip) => (
                        <div className="flex flex-col" key={$?.name}>
                            <p className="text-black text-fs14">
                                {String($?.name).split("(")[0]}
                            </p>
                            <p style={{color:$.color}} className="text-black text-fs20 font-bold">
                                {formatter($?.value)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return null;
};

const LineGraph = (props: any) => {
    const {title, dataName, dataKey, data} = props;
    let margin = {};
    if(["/FeatureImportance"].includes(location.pathname)){
        margin = { top: 20, right: 20, bottom: -10, left: -25 };
    }else{
        margin = { top: 20, right: 20, bottom: 10, left: -5 };
    }
    return (
        <div className="w-[100%] h-[100%] bg-[#FFF] shadow rounded px-[2%] py-[10px] border-[1px] border-[#BEBEBE] flex flex-col">
            <div className="flex justify-between items-center mb-[0.5vw]">
                <span className="text-mainGreen font-semibold chart-title self-start">
                    {title}
                </span>
            </div>
            <div className="flex h-[100%]">
                <div className="flex-grow h-full">
                    <ResponsiveContainer width={"100%"} height={"100%"}>
                        <LineChart data={data} margin={margin}>
                            {["/FeatureImportance"].includes(location.pathname) && 
                            <CartesianGrid vertical={true} horizontal={false} />}
                            <XAxis fontSize={"0.8vw"} dataKey="forecastDate" type="category" stroke="#949494" />
                            <YAxis interval="equidistantPreserveStart" fontSize={"0.80vw"} tickCount={10} tickFormatter={formatter} stroke="#949494" />
                            <Tooltip content={<CustomTooltip/>} />
                            <Legend
                                content={<CustomLegend/>}
                                align="left"
                                verticalAlign="top"
                                iconSize={8}
                                wrapperStyle={{ left: 0, top: 0, marginBottom: "10px" }}
                            />
                            <Line
                                name={dataName[0]}
                                dataKey={dataKey[0]}
                                stroke="#012169"
                                fill="#012169"
                                strokeWidth={2}
                                dot={{ strokeWidth: 1, r: 2 }}
                                activeDot={{ stroke: '#012169', fill: 'white', strokeWidth: 2, r: 4 }}
                            />
                            <Line
                                name={dataName[1]}
                                dataKey={dataKey[1]}
                                stroke="#86BC25"
                                fill="#86BC25"
                                strokeWidth={2}
                                dot={{ strokeWidth: 1, r: 2 }}
                                activeDot={{ stroke: '#86BC25', fill: 'white', strokeWidth: 2, r: 4 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}

export default LineGraph;
